import styled from "vue-styled-components";

const propsStyleModal = {
    widthXs: {
        default: "100%",
        type: String
    },
    maxWidthSm: {
        default: "500px",
        type: String
    },
    maxWidthMd: {
        default: "500px",
        type: String
    },
    maxWidthLg: {
        default: "800px",
        type: String
    },
    maxWidthXl: {
        default: "800px",
        type: String
    },
}

export const StyleModal = styled('div', propsStyleModal)`
    .modal {
        overflow: auto;//visible;

        .modal-dialog {
            display: flex;
            margin: auto;
            height: 100%;
            width: ${props => props.widthXs ?? '100%'};
            padding-block: 1rem;

            .modal-content {
                border-radius: 0.25rem;
                height: auto;
                margin-block: auto;
                background-color: ${props => props.theme?.background_color_site ?? '#ffffff'};

                /**.product-quick-view {
        background-color: ${props => props.theme?.background_color_site ?? '#ffffff'};
    }
    .modal-header, .modal-footer {
        border-color: ${props => props.theme?.border_color_site ?? '#e9ecef'};
    }
    .modal-header {
        .close, .close:hover {
            color: ${props => props.theme?.text_site_color ?? '#000'};
        }
    } */

                .modal-header {
                    padding-top: 1.8rem;
                    padding-bottom: 0;
                    padding-right: 3rem;
                    height: auto;
                    position: relative;

                    .close {
                        padding: 0.4rem 1.2rem;
                        color: ${props => props.theme?.background_color_site ?? '#ffffff'};
                        filter: brightness(0.5);
                        position: absolute;
                        top: 1rem;
                        right: 1rem;

                        &:hover {
                            opacity: 0.75;
                        }
                    }
                }

                .modal-body {
                    color: ${props => props.theme?.text_site_color ?? '#4a505e'};
                }

                .modal-footer {
                    height: auto;
                }
            }
        }
    }
    @media (min-width: 576px) {
        .modal-header,
        .modal-footer,
        .modal-body {
            padding-right: 2rem;
            padding-left: 2rem;
        }
        .modal-body {
            max-height: 100%;// calc(100vh - 210px);
            padding-top: 0;//2rem;
            overflow-y: auto;
        }
        .modal-dialog {
            max-width: ${props => props.maxWidthSm ?? '540px'};
        }
    }
    @media (min-width: 768px) {
        .modal-dialog {
            max-width: ${props => props.maxWidthMd ?? '720px'};
        }
    }
    @media (min-width: 992px) {
        .modal-dialog {
            max-width: ${props => props.maxWidthLg ?? '960px'};
        }
    }
    @media (min-width: 1200px) {
        .modal-dialog {
            max-width: ${props => props.maxWidthXl ?? '1140px'};
        }
    }
`;
